import { render, staticRenderFns } from "./CelebrityProgram.vue?vue&type=template&id=2f9d7895&lang=pug&"
import script from "./CelebrityProgram.vue?vue&type=script&lang=js&"
export * from "./CelebrityProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports